import React from 'react';

type PrimaryButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const PrimaryButton: React.FC<PrimaryButtonProps> = ({ children, ...props }) => (
    <button {...props} style={{ ...baseStyle, ...props.style }}>
        {children}
    </button>
);

const baseStyle: React.CSSProperties = {
    padding: 11,
    background: '#2d7a50',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    fontFamily: "'Caveat',cursive",
    fontSize: 17,
    fontWeight: 700,
    cursor: 'pointer',
    width: '100%',
};

export default PrimaryButton;
